import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";
import {EWASTE_API_PATHS, HTTP_METHOD, PROCESS_NAME} from "../constants/EWasteApiPaths";

const metricProcessName = "SCC_EWASTE_WTN_DOWNLOAD";
const SUB_PROCESS = "getBatchWasteTransferNotePreSignedUrls";

// WADM caps a single request at 10 order numbers (OrderNumberList model max).
// Callers with more selections must chunk into batches of this size.
export const WTN_PRESIGNED_URL_BATCH_SIZE = 10;

/**
 * Calls OculusService.GetBatchWasteTransferNotePreSignedUrls via Boson
 * FlowApiGateway to fetch presigned download URLs for WTN PDFs.
 *
 * @param {string[]} orderNumberList Order numbers to fetch URLs for (max 10).
 * @returns {Promise<{success: boolean, urlMap: Object}>} urlMap maps each
 *          order number to its WTN PDF presigned URL.
 */
export async function getBatchWasteTransferNotePreSignedUrls(orderNumberList) {
    const startTime = Date.now();
    const request = {
        resourcePath: EWASTE_API_PATHS.GET_BATCH_WTN_PRESIGNED_URLS,
        httpMethod: HTTP_METHOD.POST,
        processName: PROCESS_NAME.OCULUS,
        requestBody: {orderNumberList}
    };

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, SUB_PROCESS, true);
            return {
                success: true,
                urlMap: (response.data && response.data.orderNumberToPreSignedUrlMap) || {}
            };
        }
        logOperationalMetric(startTime, metricProcessName, SUB_PROCESS, false);
        return {success: false, urlMap: {}};
    } catch (error) {
        logOperationalMetric(startTime, metricProcessName, SUB_PROCESS, false);
        return {success: false, urlMap: {}};
    }
}



// WEBPACK FOOTER //
// ./src/commons/api/GetBatchWasteTransferNotePreSignedUrls.js